<template>
  <div id="app" :style="{'--themecolor': defaultTheme}">
    <div class="wrap_start"v-if="startshowflag && this.$route.path=='/' && !tokenshow">
      <div class="wrap_start_logo" v-if="logoUrl"><img :src="logoUrl" /></div>
      <div class="wrap_start_mainname" v-html="mainname"></div>
      <div class="wrap_start_phone"><a>{{ phoneinfo  }}</a> <template v-if="orgPhone2"> / <a
            v-html="orgPhone2"></a></template>
      </div>
      <div class="wrap_start_address" v-html="addressinfo"></div>
      <div class="wrap_start_btn" @click="startfun">{{ 'Appointment' }}</div>
    </div>
    <router-view  class="router-view" ></router-view>
  </div>
</template>
<script>
import { selectutop } from '@/api/getmenu'
import { selectonline } from '@/api/init'
import { checkamount } from '@/api/login'
export default {
  data () {
    return {
      defaultTheme: '#ff6d8a',
      startshowflag: true,
      logoUrl: '',
      mainname: '',
      phoneinfo: '',
      orgPhone2: '',
      addressinfo: ' ',
      ishome: false,
      // 是否欠费
      isBalance: false
    }
  },
  mounted () {
    console.log('App mounted', this.$route.path, this.$route.name, window.location.href)
    selectutop().then(res => {
      if (res && res[0]) {
        const data = res[0]
        this.mainname = data.MainName
        this.phoneinfo = data.Tel
        this.orgPhone2 = data.SecondTel
        this.addressinfo = `${data.Street || ''} ${data.City || ''} ${data.State || ''} ${data.Zip || ''}`
        this.$store.commit('utop', res[0])
      }
    })
    // 检查是否欠费
    checkamount().then(res => {
      if (res.code == 200) {
        this.$store.commit('SET_ISBALANCE', res.data)
      }
    })
    selectonline().then(res => {
      if (res.code == 200) {
        const setting = {}
        if (res.Rounding && res.Rounding.length > 0) {
          res.Rounding.forEach(item => {
            setting[item.display_key] = item.display_value
          })
        }
        this.$store.commit('SET_ONLINESETTING', setting)
      }
    })
  },
  computed: {
    // defaultTheme () {
    //   return this.$store.state.settings.theme
    // }
    tokenshow () {
      console.log('tokenshow', window && window.location.href.includes('token'))
      return window && window.location.href.includes('token')
    }
  },
  methods: {
    startfun () {
      this.startshowflag = false
    }
  },
  filters: {
    phoneformat: function (phoneNo) {
      if (phoneNo) {
        let info = ''
        if (phoneNo.length <= 3) {
          info = phoneNo
        }
        if (phoneNo.length <= 6 && phoneNo.length > 3) {
          info = phoneNo.substr(0, 3) + '-' + phoneNo.substr(3)
        }

        if (phoneNo.length > 6) {
          info = phoneNo.substr(0, 3) + '-' + phoneNo.substr(3, 3) + '-' + phoneNo.substr(6)
        }
        if (phoneNo.length > 10) {
          info = phoneNo.substr(0, 3) + '-' + phoneNo.substr(3, 3) + '-' + phoneNo.substr(6, 4) + '/' + phoneNo.substr(10)
        }

        return info
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.router-view {
  height: 100%;
}
.wrap_start {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  background-color: #fff;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.wrap_start_logo img {
  width: 80px;
}

.wrap_start_mainname {
  margin-top: 20px;
  font-size: 1.2em;
  font-weight: bold;
}

.wrap_start_phone {
  margin-top: 20px;
  font-size: 1.2em;
  font-weight: bold;
}

.wrap_start_address {
  margin-top: 10px;
  max-width: 80%;
}

.wrap_start_remark {
  margin-top: 10px;
  color: #999;
}

.wrap_start_btn {
  width: 320px;
  height: 60px;
  line-height: 60px;
  margin-top: 50px;
  border-radius: 10px;
  background-color: var(--themecolor);
  color: #000;
  text-align: center;
  font-size: 1.2em;
}

</style>
